import { openBlock as t, createElementBlock as e, createStaticVNode as h } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ h('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#0052B4" d="M20 0C13.938 0 8.507 2.697 4.84 6.956h30.32A19.95 19.95 0 0 0 20 0Zm15.161 33.044H4.84C8.507 37.303 13.94 40 20 40c6.062 0 11.494-2.697 15.161-6.956Z"></path><path fill="#D80027" d="M37.065 9.565H2.935A19.906 19.906 0 0 0 0 20c0 3.824 1.074 7.397 2.936 10.435h34.129A19.905 19.905 0 0 0 40 20c0-3.824-1.074-7.397-2.935-10.435Z"></path><path fill="#F0F0F0" d="M12.305 27.696a7.696 7.696 0 1 0 0-15.392 7.696 7.696 0 0 0 0 15.392Z"></path><path fill="#D80027" d="m12.305 12.304 1.726 5.315h5.597l-4.53 3.284 1.74 5.33-4.533-3.3-4.528 3.294 1.734-5.324-4.526-3.284h5.593l1.727-5.315Z"></path>', 5), a = [
  l
];
function c(n, p) {
  return t(), e("svg", o, [...a]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
